<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3"><a id="page_3"></a><strong>I GOT RUBBER BAND BANKS IN MY POCKET</strong></h3>
<p class="noindentb"><span class="small">LYRIC FROM SONG: <strong>“WHATEVER YOU LIKE”</strong> ON ALBUM: <strong>PAPER TRAIL</strong> BY ARTIST</span>: <strong>T.I.</strong></p>
<p class="noindent">I carry such large amounts of cash around with me that a wallet would quickly wear out as it would be stretched beyond the capacity to hold the currency for which it was designed. A common alternative to the wallet, the money clip, is pushed beyond its mechanical limit as well. Therefore, a large rubber band will be employed, as it can expand with increased capacity.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01ch02.vue?a419f698